import { Breadcrumbs, Link } from '@mui/material';
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Typo from '../typo/Typo';
import { DEBI_REQUEST_TEXT, HOME_TEXT } from '../../../utils/constants/GlobalConstants';
const COLOR={ color: 'rgba(0, 0, 0, 0.6)' }
const BreadcrumbLayout = (props) => {
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = React.useState(props.activeLink);

  useEffect(() => {
    setActiveLink(props.activeLink)
  }, [props])

  const handleClick = (event) => {
    event.preventDefault();
    navigate('/')
  }

  const breadCrumbsHome = [
    <Typo variant='body2' text={HOME_TEXT} color="secondary" sx={COLOR} />
  ];

  const getRoutes = () => {
    let links = [];
    links.push(breadCrumbsHome);
    if (activeLink.length > 0) {
      links.push(<Link key={links.length} underline="hover" color="inherit" variant="body2" href="/" testid="breadcrumb" onClick={(event) => handleClick(event, '/')}>
        DEBI Request
      </Link>, ...activeLink)
      return links;
    }
    else {
      links.push(<Typo key={links.length} variant='body2' text={DEBI_REQUEST_TEXT} color="secondary" sx={COLOR} />)
      return links;
    }

  }

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      {getRoutes()}
    </Breadcrumbs>
  )
}

export default BreadcrumbLayout